import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public baseURL: any;

  constructor(private readonly http: HttpClient) {
    this.baseURL = environment.INNOVATE_API_V2;
  }

  public getProfilingQuestions(pid: any,supCode:number) {
    return this.http.get(environment.newBEHost + 'router/getQualifications/' + supCode + '/' + pid,{params:{isRouter:true}});
  }

  public setProfilingQuestions(pid: any, payload: any,supCode:number) {
    return this.http.post(environment.newBEHost + 'router/setQualifications/' + supCode+ '/' + pid, payload);
  }

  public personaliseModelInventroy(pid: any, payload: any,supCode:number) {
    return this.http.post(environment.newBEHost + 'router/respondent/' + supCode + '/' + pid + '/surveys', payload);
  }

  public getRDToken(obj: any) {
    return this.http.get(environment.sampleChainApiUrl + 'get_token/' + environment.sampleChain.secretKey + '?rt_sr_pd=' + obj.id);
  }

  public getRDDetails(obj: any) {
    const url = environment.sampleChainApiUrl + 'search/' + environment.sampleChain.privateKey + '?sy_nr=' + obj.surveyID + '&rt_sr_pd=' + obj.id + '&coordinates=1';
    return this.http.get(url, { headers: new HttpHeaders({ 'token': obj.token, 'Content-Type': 'application/json' }) });
  }

  public getZipcodeData(data: any) {
    return this.http.post(environment.surveyFlow_Backend + 'survey/getZipMasterData', data);
  }

  public checkZipcodeValidation(country: string, zipcode: string, supCode:number) {
    return this.http.get(environment.newBEHost + 'router/validateZipcode/' + supCode + '/' + country +'/' + zipcode);
  }

  public addUpdatePanelistProfiling( pid: any, payload:any,supCode:number){
    return this.http.post(environment.newBEHost + 'router/addUpdatePanelistProfile/'+ supCode + '/' + pid, payload);
  }
  
  public getSuplierByCondition(supCode: any) {
    return this.http.get(environment.INNOVATE_API + 'getSuplierByCondition/' + supCode);
  }

  public getGeoLocation(ip: any) {
    return this.http.post(environment.INNOVATE_API + 'getLocationRouter',ip);
  }

  public commonDecryptionMethod(obj:any){
      return JSON.parse(CryptoJS.AES.decrypt(obj.data, environment.secretKeyToEncDcryPayload).toString(CryptoJS.enc.Utf8))
  }

  public getUserIp(){
    return this.http.get(environment.pointClubDomain + 'panelists/getUserIpForRouter');
  }

}
